import { gql } from "@apollo/client"

export const DELETE_SUBMISSION_SPECIFIC_OBJECTIVES = gql`
  mutation DeleteSubmissionSpecificObjectives($ids: [ID!]!) {
    DeleteSubmissionSpecificObjectives(data: $ids)
  }
`